import classNames from 'classnames';
import { Tooltip } from 'primereact/tooltip';
import { UseFormSetValue } from 'react-hook-form';

import { IconRadioChecked, IconRadioEmpty } from '@/components/icons';
import { useTranslation } from '@/config/i18n';
import { RegisterAccountFormSchemaType } from '@/shared/schema/register-account';
import { PlanType } from '@/types/plan';

type Props = {
  plan: PlanType;
  selectedPlan?: PlanType;
  setSelectedPlan: (data: PlanType) => void;
  setValue?: UseFormSetValue<RegisterAccountFormSchemaType>;
}

const PlanItem = ({
  plan,
  selectedPlan,
  setSelectedPlan,
  setValue,
}: Props) => {
  const [t] = useTranslation('');

  return (
    <div
      key={plan.id}
      className={classNames(
        'border rounded-xl cursor-pointer transition-all',
        selectedPlan?.id === plan.id
          ? 'border border-primary-500 bg-primary-50'
          : 'border border-gray-200 bg-white',
      )}
      onClick={() => {
        setSelectedPlan(plan);
        setValue?.('plan_id', plan.id);
      }}
    >
      <label className="flex items-center gap-3 cursor-pointer w-full">
        <input
          type="radio"
          name="plan_id"
          value={plan.id}
          checked={selectedPlan?.id === plan.id}
          onChange={() => setValue?.('plan_id', Number(plan.id))}
          className="hidden"
        />
        <div className="w-full">
          <div
            className={classNames(
              'flex flex-col md:flex-row justify-between items-start px-3 py-4 gap-4 md:gap-0',
              selectedPlan?.id === plan.id
                ? 'border-b border-primary-500'
                : 'border-b border-gray-200',
            )}
          >
            <div className="flex gap-4 items-start w-full md:w-auto">
              <div className='pt-1'>
                {selectedPlan?.id === plan.id ? (
                  <IconRadioChecked />
                ) : (
                  <IconRadioEmpty />
                )}
              </div>
              <div className="w-full text-[18px] leading-[28px] text-gray-700 font-semibold">
                <Tooltip target={`.tooltip-point-${plan.id}-plan-name`}>
                  {plan.name}
                </Tooltip>
                <div
                  className={classNames(
                    'line-clamp-3 text-gray-700 break-all',
                    `tooltip-point-${plan.id}-plan-name`,
                  )}
                  data-pr-position="mouse"
                >
                  {plan.name}
                </div>
              </div>
            </div>
            <div className="flex items-center w-fit md:w-auto md:min-w-[194px] md:max-w-[220px] gap-2 px-2 py-1 border border-gray-300 rounded-md bg-white">
              <span className="h-2 w-2 bg-green-500 rounded-full"></span>
              <span className="text-gray-700 text-md font-medium">
                {t('register_account.service_section.plan.number_of_students', {
                  limit_students: plan.student_limit,
                })}
              </span>
            </div>
          </div>
          <div className="flex items-baseline p-4">
            <span className="text-4xl leading-[44px] text-gray-700 font-semibold">
              {t('register_account.service_section.plan.price', {
                price: plan.price.toLocaleString(),
              })}
            </span>
            <span className="text-md leading-[24px] text-gray-600 font-normal">
              {t('register_account.service_section.plan.unit')}
            </span>
          </div>
        </div>
      </label>
    </div>
  );
};

export default PlanItem;
